export function getUtcDate(date: Date) {
  const utcDateNumber = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())
  const utcDate = new Date(utcDateNumber)
  return utcDate
}

export function getUtcDateAsString(date: Date) {
  const utcDate = getUtcDate(date)
  return utcDate.toUTCString()
}
